<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <SmsMessageDetail slot-scope="{data}"  :status-prop="data.status" :id-prop="data.id"></SmsMessageDetail>
  </l-cache>
</template>
<script>
import SmsMessageDetail from './smsMessageDetail'
export default {
  name: 'ruleConfigBox',
  components: {SmsMessageDetail},
  methods: {
    async getItem (key) {
      return {
        status: this.$route.query.status,
        id: this.$route.query.id
      }
    }
  }
}
</script>
